import React from 'react'
import styles from './StaffingAnnouncementBanner.sass'
import { useBrandingSettings } from '../../../hooks/branding'

/**
 * A banner that announces that Staffing is enabled.
 */
export default function StaffingAnnouncementBanner() {
  const { corporateMode } = useBrandingSettings()
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>
          Exclusive outsourcing opportunities that you're qualified for!
        </p>
        <p className={styles.description}>
          From time to time, we’ll post workspace opportunities that you can
          apply for here. <LearnMoreLink />
        </p>
      </div>
      {!corporateMode && (
        <div className={styles.illustrationContainer}>
          <img
            className={styles.illustration}
            alt="Hand holding a diamond"
            src={require('assets/images/img_banner-staffing-taxfyle.svg')}
          />
        </div>
      )}
    </div>
  )
}

/**
 * A link to learn more about the new routing mode.
 */
function LearnMoreLink() {
  return (
    <a
      className={styles.learnMoreLink}
      href="https://drive.google.com/file/d/1MEYPuvjOu5FvX_VuALIxaqOCyJKT6g1j/view"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </a>
  )
}
